module.exports = "<div class=\"sort_label\">\r\n    <span>{{products.letter}}</span>\r\n</div>\r\n<product-item *ngFor=\"let product of products.products\" [product]=product ></product-item>"


//////////////////
// WEBPACK FOOTER
// ./src/app/labelled-products/labelled-products.component.html
// module id = 734
// module chunks = 0